<script setup lang="ts">
    import { computed, toRef } from 'vue'
    import type { PropType } from 'vue'
    import { tchMarked } from "@common/Common"
    import type { CriterionDetailsDialogViewModel } from "@Criteria/Hierarchies/Components/CriterionDetailsDialog"

    // ---------------- props ----------------

    const props = defineProps({
        viewModel: {
            type: Object as PropType<CriterionDetailsDialogViewModel>,
            required: true
        }
    })

    // ---------------- state ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value.isOpen)

    const name = computed(() => vm.value.name)
    const path = computed(() => vm.value.path)
    const description = computed(() => vm.value.description)

    const descriptionHtml = computed(() => tchMarked(description.value))

    // ---------------- actions ----------------

    function close()
    {
        vm.value.close()
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <span>{{name}}</span><br />
                            <small class="text-muted">{{path}}</small>
                        </h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <p v-if="!description" class="text-muted font-italic lead">No description provided</p>
                        <div v-html="descriptionHtml"></div>
                    </div>

                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>